var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form", { attrs: { "data-vv-scope": "data-group" } }, [
    _c("div", { staticClass: "row mb-5" }, [
      _c(
        "div",
        { staticClass: "col-md-6 mt-3" },
        [
          _c("vs-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            staticClass: "w-100",
            attrs: {
              label: "Código",
              maxlength: "40",
              name: "groupCode",
              danger: _vm.errors.has("data-group.groupCode"),
              "danger-text": _vm.errors.first("data-group.groupCode")
            },
            model: {
              value: _vm.editGroup.codigo,
              callback: function($$v) {
                _vm.$set(_vm.editGroup, "codigo", $$v)
              },
              expression: "editGroup.codigo"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-md-6 mt-3" },
        [
          _c("vs-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            staticClass: "w-100",
            attrs: {
              label: "Nombre de la oficina",
              maxlength: "250",
              name: "groupName",
              danger: _vm.errors.has("data-group.groupName"),
              "danger-text": _vm.errors.first("data-group.groupName")
            },
            model: {
              value: _vm.editGroup.nombre,
              callback: function($$v) {
                _vm.$set(_vm.editGroup, "nombre", $$v)
              },
              expression: "editGroup.nombre"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-md-12 mt-3" },
        [
          _c("vs-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            staticClass: "w-100",
            attrs: {
              label: "Descripción de la oficina",
              maxlength: "250",
              name: "groupDescription",
              danger: _vm.errors.has("data-group.groupDescription"),
              "danger-text": _vm.errors.first("data-group.groupDescription")
            },
            model: {
              value: _vm.editGroup.descripcion,
              callback: function($$v) {
                _vm.$set(_vm.editGroup, "descripcion", $$v)
              },
              expression: "editGroup.descripcion"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-md-6 mt-3" },
        [
          _c(
            "vs-select",
            {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              ref: "region",
              staticClass: "w-100",
              attrs: {
                autocomplete: "",
                label: _vm.isMop ? "Regiones" : "Categorias",
                "description-text": "Si no hay debe crearlas en mantenedor",
                id: "region",
                name: "region",
                danger: _vm.errors.has("data-group.region"),
                "danger-text": _vm.errors.first("data-group.region"),
                placeholder: _vm.isMop
                  ? "Seleccione una región"
                  : "Seleccione una categoría"
              },
              model: {
                value: _vm.editGroup.regionId,
                callback: function($$v) {
                  _vm.$set(_vm.editGroup, "regionId", $$v)
                },
                expression: "editGroup.regionId"
              }
            },
            _vm._l(_vm.categoryRegions, function(region, index) {
              return _c("vs-select-item", {
                key: index,
                attrs: { value: region.opcionId, text: region.descripcion }
              })
            }),
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-md-6 mt-3" },
        [
          _c(
            "vs-select",
            {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              ref: "servicio",
              staticClass: "w-100",
              attrs: {
                autocomplete: "",
                label: _vm.isMop ? "Servicios" : "Subcategorias",
                "description-text": "Si no hay debe crearlos en mantenedor",
                id: "servicio",
                name: "servicio",
                danger: _vm.errors.has("data-group.servicio"),
                "danger-text": _vm.errors.first("data-group.servicio"),
                placeholder: _vm.isMop
                  ? "Seleccione un servicio"
                  : "Seleccione una subcategoría"
              },
              model: {
                value: _vm.editGroup.servicioId,
                callback: function($$v) {
                  _vm.$set(_vm.editGroup, "servicioId", $$v)
                },
                expression: "editGroup.servicioId"
              }
            },
            _vm._l(_vm.categoryServices, function(service, index) {
              return _c("vs-select-item", {
                key: index,
                attrs: { value: service.opcionId, text: service.descripcion }
              })
            }),
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "col-md-12 mt-5" }, [
        _c("div", { staticClass: "row" }, [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "col-md-4" },
            [
              _c(
                "vs-radio",
                {
                  attrs: {
                    "data-cy": "internalOffice",
                    "vs-name": "isPrivate",
                    "vs-value": "int"
                  },
                  model: {
                    value: _vm.editGroup.tipo,
                    callback: function($$v) {
                      _vm.$set(_vm.editGroup, "tipo", $$v)
                    },
                    expression: "editGroup.tipo"
                  }
                },
                [_vm._v(" Interna ")]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-4" },
            [
              _c(
                "vs-radio",
                {
                  attrs: {
                    "data-cy": "externalOffice",
                    "vs-name": "isPrivate",
                    "vs-value": "ext"
                  },
                  model: {
                    value: _vm.editGroup.tipo,
                    callback: function($$v) {
                      _vm.$set(_vm.editGroup, "tipo", $$v)
                    },
                    expression: "editGroup.tipo"
                  }
                },
                [_vm._v(" Oficina de partes ")]
              )
            ],
            1
          )
        ])
      ]),
      _c("div", { staticClass: "col-md-12 mt-3" }, [
        _c(
          "div",
          { staticStyle: { float: "right" } },
          [
            _c(
              "vs-button",
              {
                staticClass: "action",
                attrs: {
                  "data-cy": "save",
                  color: "primary",
                  type: "border",
                  icon: "save"
                },
                on: {
                  click: function($event) {
                    return _vm.saveChanges()
                  }
                }
              },
              [_vm._v(" Guardar ")]
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4" }, [
      _c("label", [_vm._v("Esta oficina va a tener numeración")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }